import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { getUnixTime } from '@client/core/utils/date';
import {
  SubscriptionPlanKeyV1,
  SubscriptionPlanKeyV2,
  SubscriptionPlanKeyV2Analysis,
  UpdateSubscriptionPlanStatus,
} from '@client/features/billing/config';
import { SubscriptionPlan } from '@client/features/subscription-plan/models/subscription-plan';

interface SelectPlanResponse {
  status: UpdateSubscriptionPlanStatus;
  message: string;
  subscriptionPlan: SubscriptionPlan | null;
}

export class SubscriptionPlanDataSource extends DataSource {
  async selectPlan(
    planKey: SubscriptionPlanKeyV1 | SubscriptionPlanKeyV2 | SubscriptionPlanKeyV2Analysis,
    prorateAt: Date,
  ): Promise<SelectPlanResponse> {
    const response = await this.httpClient.post<{
      status: UpdateSubscriptionPlanStatus;
      message: string;
      plan?: JsonResponse;
    }>('/billing/select-plan', { planKey, prorateAt: getUnixTime(prorateAt) });

    return {
      status: response.data.status,
      message: response.data.message,
      subscriptionPlan: response.data.plan ? fromJson(SubscriptionPlan, response.data.plan) : null,
    };
  }
}
